<p-table
    #dt
    [value]="listSim"
    [rowHover]="true"
    dataKey="id"
    selectionMode="single"
    [(selection)]="selectedDemand"
    [rows]="pagination?.per_page"
    [globalFilterFields]="table.globalFilterFields"
    responsiveLayout="scroll"
    scrollable="true"
    scrollHeight="flex"
    width="100%"
    class="responsive-claims-table"
>
    <ng-template pTemplate="caption">
        <div class="d-flex justify-content-between">
            <app-table-title
                [count]="pagination?.total"
                [legendePluriel]="'dossiers'"
                [perPage]="pagination?.per_page"
                [legendeSingulier]="'dossier'"
                [page]="pagination?.current_page"
                [totalPage]="pagination?.last_page"
                responsiveLayout="scroll"
                scrollable="true"
                scrollHeight="flex"
                width="100%"
                class="responsive-claims-table"
            >
            </app-table-title>
            <div class="d-flex gap-2 align-items-center">
                <div class="d-flex gap-2">
                    <app-table-button-header
                        (refresh)="pageCallback()"
                        (export)="onExportExcel()"
                        [disabledButtonExport]="listSim?.length === 0"
                        [colorOther]="'dark'"
                        [hiddenButtonOther]="true"
                    >
                    </app-table-button-header>
                </div>
                <div>
                    <app-search-table [dt]="dt"></app-search-table>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th
                *ngFor="let col of table.cols"
                [class]="col.class"
                [ngStyle]="{
                    minWidth: col.width,
                    width: col.width,
                    textAlign: 'center'
                }"
            >
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'Date / Heure'">
                        {{ 'DATE_TIME' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'N° Transaction'">
                        {{ 'NUMBER_TRANSACTION' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'IMSI'">
                        {{ 'IMSI' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'MSISDN'">
                        {{ 'MSISDN' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Etape'">
                        {{ 'STEP' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Etat'">
                        {{ 'STATE' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Date Etat'">
                        {{ 'UPDATED_DATE' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ col.header }}
                    </ng-container>
                </ng-container>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-dossier>
        <tr [pSelectableRow]="dossier">
            <td
                *ngFor="let col of table.cols"
                [class]="col.class"
                [ngStyle]="{ minWidth: col.width, width: col.width }"
                [attr.data-label]="col.header"
            >
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'#'">
                        {{ rowIndex + pagination?.current_page }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'N° Transaction'">
                        <span (click)="copyToClipboard(dossier?.[col.field])">
                            {{ dossier?.[col.field] }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'IMSI'">
                        <span (click)="copyToClipboard(dossier?.[col.field])">
                            {{ dossier?.[col.field] }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'MSISDN'">
                        <span (click)="copyToClipboard(dossier?.[col.field])">
                            {{ dossier?.[col.field] }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Etape'">
                        <span
                            [ngStyle]="{ 'font-size': '16px' }"
                            [class]="'badge ' + getEtapeBadge(dossier)"
                        >
                            {{ dossier?.[col.field] }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Etat'">
                        <span
                            [ngStyle]="{ 'font-size': '16px' }"
                            [class]="'badge ' + getEtatBadge(dossier)"
                        >
                            {{ dossier?.[col.field] }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Date Etat'">
                        {{ dossier?.[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Actions'">
                        <!-- <button
                            pButton
                            icon="pi pi-eye"
                            pTooltip="Voir"
                            tooltipPosition="top"
                            class="p-button-dark"
                            (click)="
                                handleAction({
                                    data: dossier,
                                    action: 'view-sim-demand',
                                    view: 'modal'
                                })
                            "
                        ></button
                        >&nbsp; -->
                        <button
                            pButton
                            icon="pi pi-book"
                            class="p-button-primary"
                            pTooltip="Journal"
                            (click)="
                                handleAction({
                                    data: dossier,
                                    action: 'journal-sim-demand',
                                    view: 'modal'
                                })
                            "
                        ></button>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{dossier?.[col.field]}}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr *ngIf="listSim?.length <= 0 && !spinner">
            <td class="posRelative" colspan="15">
                <span class="posCenter">
                    {{ 'NO_DATA_FOUND' | translate }}
                </span>
            </td>
        </tr>
        <tr *ngIf="spinner">
            <td class="posRelative" colspan="15">
                <p-progressSpinner
                    class="posCenter"
                    [style]="{ width: '40px', height: '50px' }"
                    styleClass="custom-spinner"
                    strokeWidth="8"
                    fill="#EEEEEE"
                    animationDuration=".5s"
                >
                </p-progressSpinner>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog
    [header]="'[Suivi & Traitement] Demande ['+selectedDemand?.['numero_demande']+']'"
    [(visible)]="visibleFormLine"
    (onHide)="hideDialog()"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '100%', 'min-height': '100%' }"
    [responsive]="true"
    [maximizable]="true"
    [draggable]="false"
    [resizable]="true"
>
    <ng-template pTemplate="content">
        <app-form-sim-demand
            [demandSelected]="selectedDemand"
            (visibleFormDossier)="hideDialog()"
        ></app-form-sim-demand>
    </ng-template>
</p-dialog>
